export default {
    attendaceEmployee: 'สถานะพนักงานเข้างาน',
    late: 'มาสาย',
    absent: 'ขาด',
    onsite: 'เข้าหน้างาน',
    leave: 'ลา',
    checkOut: 'ออกปกติ',
    earlyCheckOut: 'ออกก่อน',
    employeeNo: 'รหัสพนักงาน',
    fullName: 'ชื่อ - นามสกุล',
    timeCi: 'เวลาเข้างาน',
    timeCo: 'เวลาออกงาน',
    status: 'สถานะ'
}
